import { gql } from "@apollo/client";

export const GET_PAYMENT_INFO = gql`
  query GetPaymentInfo {
    paymentInfo {
      publicKey
    }
  }
`;

export const GET_CUSTOMER_BILLING_PORTAL_LINK = gql`
  query GetCustomerBillingPortalLink {
    billingPortalLink {
      success
      message
      sessionUrl
      sessionId
    }
  }
`;

export const GET_USER_SUBSCRIPTION_INFO = gql`
  query {
    userSubscriptionInfo {
      subscriptionStatus
      planName
      nextBillingDate
      monthlyCost
      success
    }
  }
`;
export const GET_SCHOOL_SUBSCRIPTION_TYPES = gql`
  query {
    schoolSubscriptionTypes
  }
`;
export const GET_POSSIBLE_USER_SUBSCRIPTION_PLANS = gql`
  query {
    subscriptionPlans {
      id
      name
      description
      price
      stripePriceId
      features {
        id
        feature
      }
    }
  }
`;
